// trackpoint array metrics calculator!

// data structure for raw points:
// y: lat in decimal degrees
// x: lng in decimal degrees
// d: distance provided by recording device
// e: elevation
// t: unix timestamp (seconds)
// p: power
// s: not sure yet, possibly speed?
// T: temperature in degrees C
import { conversions as C } from 'lib/units'
import { SincFilter } from './filters'
import { getConsole } from 'lib/getConsole'
import * as geoUtils from 'lib/geoUtils'
const console = getConsole('lib', 'metricsCalculator')
const n = d => Number.isFinite(d) ? d : null

export const trackpointMetrics = (trackpoints) => {
  console.log(`trackpointMetrics cache miss for array of ${trackpoints.length} trackpoints`)
  // running tallies
  let currentDistance = 0
  let lastPointWithPosOrDistance = trackpoints[0]

  const metrics = trackpoints.map((point, index) => {
    // const prevPoint = index > 0 && trackpoints[index - 1]

     // eslint-disable-line

    const distanceDelta = getDistanceDelta(lastPointWithPosOrDistance, point)
    const timeDelta = point.t - lastPointWithPosOrDistance.t
    const hasValidPosition = validPosition(point)
    const speed_orig = Number.isFinite(point.s) // eslint-disable-line
      ? C.mpsToKph(point.s)
      : (distanceDelta !== null && timeDelta > 0) ? C.mpsToKph(distanceDelta / timeDelta) : null

    if (distanceDelta) {
      currentDistance += distanceDelta
    }

    if (point.d || hasValidPosition) {
      lastPointWithPosOrDistance = point
    }

    return {
      cad: n(point.c),
      ele: n(point.e),
      providedDistance: point.d || null,
      speed_orig: speed_orig,
      temp: n(point.T),
      time: n(point.t),
      watts: n(point.p),
      lat: n(point.y),
      lng: n(point.x),
      distance: currentDistance,
      goodPoint: point.d !== undefined || hasValidPosition,
      excludeFromMetrics: !!point.k,
      color: n(point.color)
    }
  })

  const smoothedSpeeds = smoothSpeeds(metrics, trackpoints)

  return metrics.map((p, i) => ({ ...p, speed: smoothedSpeeds[i] }))
}

const getDistanceDelta = (a, b) => {
  if (!a || !b) { return null }
  if (a.d && b.d) {
    return b.d - a.d
  } else if (validPosition(a) && validPosition(b)) {
    return geoUtils.pointDistance([a.y, a.x], [b.y, b.x])
  }
  return null
}

const validPosition = point => (
  point.y && point.x &&
  point.y >= -90 && point.y <= 90 &&
  point.x >= -180 && point.x <= 180
)

const smoothSpeeds = (points, rawData) => {
  const speeds = points
    .map(p => p.goodPoint ? p.speed_orig : null) // redo speed calculation for points without distance

  // this works, but we don't appear to be pre-processing the speeds correctly
  // since the data we get out of this is off by > 1kph in some points
  //
  // todo
  // - implement the moving time delta check to zero out nonmoving points
  // - implement outlier discarding for points with an acceleration that is too
  //   high
  const speedDists = points.map(p => p.distance)
  const filter = new SincFilter(speedDists, speeds)
  const smoothedSpeeds = filter.filter()
  return smoothedSpeeds
}

export const aggregateMetrics = (trackpoints) => {
  console.log(`cache miss on aggregateMetrics for array of ${trackpoints.length} trackpoints`)
}
